import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams, Link, useNavigate } from "react-router-dom";
import CourseDetailContent from "./CourseDetailContent";
import Completion from "../common/Completion";
import {
  getMypageCourseApplicant,
  postCourseApplication,
} from "../../../../services/apiCourseApplicant";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

const CourseApplication = () => {
  // 講座ID
  const { id } = useParams();
  // 講座詳細データ
  const [detailData, setDetailData] = useState([]);
  // 一覧に戻るリンク用
  const navigate = useNavigate();
  // 同意したかどうかのフラグ
  const [isConsent, setConsent] = useState(false);
  // 完了画面かどうかのフラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  // ローディング表示
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  // 講座データ表示
  const returnContent = () => {
    return <CourseDetailContent detailData={detailData} />;
  };

  // 同意するチェック
  const ConsentCheck = (e) => {
    setConsent(e.target.checked);
  };

  // 申し込みを確定するボタン
  const onSubmit = async (data) => {
    const json = await postCourseApplication(id, data);
    if (json?.result) {
      setIsCompFlg(true);
      scrollTop();
    }
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  useEffect(() => {
    // ローディング表示開始
    setLoading(true);
    // 講座申込情報取得
    (async function () {
      const data = await getMypageCourseApplicant({ id });
      if (data == undefined || !data) return;
      if (data.applicant_id || !data.in_period) {
        // 既に申し込んでいたら or 申込期間外だったら404エラー
        navigate("/mypage/notfound");
      }
      // データが取得できたらローディング表示終了
      setLoading(false);
      setDetailData(data);
      setValue("course_name", data.course_name);
      setValue("university_id", data.univ_id);
      // キャンセル可否によって同意したかどうかのフラグを変える
      if (data.is_cancelable_pure) {
        setConsent(true);
        setValue("is_dont_canncel", null);
      }
      setValue("cancel", data.cancel);
    })();
  }, []);
  return (
    <>
      {isCompFlg ? (
        <Completion
          title="講座申し込み完了"
          explanation="講座のお申し込みを完了致しました。"
          link="/mypage/course/search/accepting"
          btntext="講座検索ページに戻る"
        />
      ) : (
        <div className="l-page-right">
          <div className="l-page-con">
            <div className="p-warning">
              まだ申し込みは完了していません。
              <br />
              下記の内容をご確認の上、「申し込みを確定する」ボタンをクリックしてください。
            </div>
            <div className="p-user-link">
              <div className="p-user-link-item">
                <Link to="/mypage/course/search/accepting">一覧へ戻る</Link>
              </div>
              <div className="p-user-link-item">
                <a
                  className="p-user-link01"
                  href={
                    process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN +
                    "/mypage-manual/"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  使い方を見る（新しいウィンドウで開きます）
                </a>
              </div>
            </div>
            {returnContent()}
            <form onSubmit={handleSubmit(onSubmit)}>
              {detailData.is_cancelable_pure ? (
                <div hidden>
                  <input
                    type="checkbox"
                    name="is_dont_canncel"
                    {...register("is_dont_canncel")}
                  />
                </div>
              ) : (
                <div className="p-warning">
                  <p>この講座は、申込期間終了後のキャンセルはできません。</p>
                  <p>
                    やむを得ず欠席される場合は、講座前に渋谷ハチコウ大学事務局（hachikou-university@shibuya.tokyo）宛にメールでご連絡ください。
                  </p>
                  <p>
                    大学連携講座は、申込期間終了後は受講料のお支払いが必要になり、返金もできかねますのでご注意ください。
                  </p>
                  <div className="text-center">
                    <label className="mt-3 text-body">
                      <input
                        type="checkbox"
                        name="is_dont_canncel"
                        {...register("is_dont_canncel")}
                        onChange={(e) => ConsentCheck(e)}
                      />
                      同意する
                    </label>
                  </div>
                </div>
              )}
              <div hidden>
                <input
                  type="text"
                  name="course_name"
                  {...register("course_name")}
                />
                <input
                  type="text"
                  name="university_id"
                  {...register("university_id")}
                />
                <input
                  type="text"
                  name="how_apply"
                  {...register("how_apply")}
                />
                <input type="text" name="cancel" {...register("cancel")} />
              </div>
              <div className="p-login-form__btnbox">
                <div className="p-login-form__returnbtn">
                  <input
                    className="p-login-form__link"
                    type="button"
                    value="戻る"
                    onClick={() => navigate("/mypage/course/detail/" + id)}
                  />
                </div>
                <div className="p-login-form__send">
                  <input
                    className="p-login-form__link"
                    type="submit"
                    value="申し込みを確定する"
                    disabled={!isConsent}
                  />
                </div>
              </div>
            </form>
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </div>
      )}
    </>
  );
};

export default CourseApplication;
